import { Button } from "@material-ui/core";
import { setLanguage } from "../redux/actions/Languages";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../redux/Store";
import { createEntity } from "../redux/actions/Entity";
import { User, UserJson } from "../models/User";
import { Action } from "./base/Action";
import ShowMessage from "./ShowMessage";
import ThemeSwitcher from "./base/ThemeSwitcher";
import { useContext } from "react";
import { CustomThemeContext } from "./base/CustomThemeProvider";

export default function Playground() {
  const dispatch = useDispatch();
  let language = useSelector(
    (state: AppState) => state.languageReducer.language
  );
  let uobj = useSelector((state: AppState) => state.apiReducer.user);
  let control = useSelector((state: AppState) => state.otherReducer.control);

  function button1() {
    if (language === "en") dispatch(setLanguage("fr"));
    else dispatch(setLanguage("en"));
  }

  function button2() {
    if (uobj != null) {
      let u = new User(uobj as UserJson);
      alert("User parsed");
      alert(JSON.stringify(u));
    }
    dispatch(createEntity("test", "1"));
  }

  function button3() {
    if (control === "button") dispatch({ type: "ICON_CHANGE", data: "icon" });
    else dispatch({ type: "ICON_CHANGE", data: "button" });
  }

  return (
    <>
      <Button onClick={button1}>Switch Language</Button>
      <Action onClick={button2} type={"button"}>
        Call user
      </Action>
      <Action onClick={button3} type={control} props={{ src: "/logo192.png" }}>
        SS
      </Action>
      <ShowMessage type={"button"}>Another button</ShowMessage>
      <ShowMessage type={"icon"} props={{ src: "/logo192.png", width: "5%" }} />
      <ShowMessage type={"checkbox"}></ShowMessage>
      <ThemeSwitcher />
    </>
  );
}
